import { loadUserData } from '.';

export default class CommandsController {
  _requestService;
  _paths;
  _persistance;

  constructor(requestService, paths, persisttance) {
    this._requestService = requestService;
    this._paths = paths;
    this._persistance = persisttance;
  }

  async loginRequest({ username, password }) {
    const token = Buffer.from(username + ':' + password).toString('base64');
    return new Promise((resolve, reject) => {
      let headers = {
        Authorization: 'Basic ' + token,
        'Content-Type': 'application/json',
      };
      this._requestService
        .Post(this._paths.loginPath, null, headers)
        .then(async ({ data }) => {
          if (this.containsKey(data, 'access_token')) {
            this._persistance.persistValue('AccessToken', data['access_token']);
            this._persistance.persistValue('RefreshToken', data['refresh_token']);
            await loadUserData();
          }
          resolve(data);
        })
        .catch((error) => {
          if (error.response && error.response.status == 403) {
            reject(error.response.data);
          } else {
            console.log('error', error);
            reject('An error has occurred. Please reload the page again.');
          }
        });
    });
  }

  async recoverPasswordRequest({ email }) {
    return new Promise((resolve, reject) => {
      this._requestService
        .Post(this._paths.passwordRecoveryPath, { email })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  }

  async registerChild({
    name,
    last_name,
    modulesUnlocked,
    email,
    birthdate,
    password,
    re_password,
    parent,
    profile_gender,
  }) {
    let params = {
      name,
      last_name,
      modulesUnlocked,
      email,
      birthdate,
      password,
      re_password,
      profile_gender,
    };
    try {
      const path = this._paths.registerChildPath;
      const { data } = await this._requestService.Post(path, params);
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, Failed to register child.');
    }
  }

  async setRefreshToken({ refreshToken }) {
    try {
      const path = this._paths.refreshToken;
      const { data } = await this._requestService.Post(path, {
        refresh_token: refreshToken,
      });
      return data;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not generate new token.');
    }
  }

  containsKey = (obj, key) => Object.keys(obj).includes(key);
}
